import BlockType7Component from '@headlines/components/block/1-10/BlockType7.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType7: AdminBlockType = {
  component: BlockType7Component,
  attributes: AdminBlockTypeAttributes({
    icons: true,
    author: false,
    titleComment: true,
    channel: false,
    category: false,
    relatedTitles: true,
    lead: false,
  }),
  articlesCount: 12,
};

export default AdminBlockType7;
